import React, { Component } from 'react';
// import Sidebar from './Sidebar'
import Sidebar2 from './Sidebar2'
import Map from './Map'
import {format} from "d3-format";
import YearChanger from './YearChanger';
import Explainer from './Explainer';
import Loader from './Loader';
import {interpolateRgb} from 'd3-interpolate';

const Apper = ({active_year, active_price, active_mode, active_probability, map, neighborhoods, neighborhoods_samples, changeActiveYear, changeActivePrice, mapLoaded, getNeighborhoodsSamples, changeActiveMode, changeActiveProbability, price_focus, probability_focus, changePriceFocus, changeProbabilityFocus, setActiveNeighborhood, active_neighborhood, active_neighborhood_with_samples, closeNeighborhoodFocus, borough_filter, setBoroughFilter, hexes, setActiveHex, active_hex, active_hex_with_samples, closeHexFocus, show_roads, setShowRoads, explainer, setExplainer, browser_width, mobile_toggle, toggleMobile, prospectHeights2010, prospectHeights2016, getNeighborhoodHexes, mobile_show, changeMobileShow}) => {

  const borough_abbreviations = {
    brooklyn: 'BK',
    bronx: 'BX',
    manhattan: 'MN',
    queens: 'QN',
    'staten island': 'SI'
  }

  const formatters = {
    percentFormat: format('.0%'),
    dollarFormat: format('$,'),
    dollarShort: format('$.2s'),
    dollarThree: format('$.3s'),
    commas: format(','),
    borough_abbreviations
  }

  const chanceInterpolator = (value) => {
    if (value > 1) {
      return '#866ff2';
    } else {
      return interpolateRgb('#fff','#866ff2')(value);
    }
  }

  const moneyInterpolator = (value) => {
    if (value > 1) {
      return '#e66101';
    } else {
      return interpolateRgb('#fff','#e66101')(value);
    }
  }

  const interpolators = {
    chance: chanceInterpolator,
    money: moneyInterpolator
  }

  let filtered_neighborhoods = neighborhoods;
  if (borough_filter && neighborhoods) filtered_neighborhoods = neighborhoods.filter((neighborhood) => neighborhood.properties.borough === borough_filter ? true : false);

  return (
    <div>
      <Map
        active_year={active_year}
        active_price={active_price}
        map={map}
        neighborhoods={neighborhoods}
        price_focus={price_focus}
        neighborhoods_samples={neighborhoods_samples}
        mapLoaded={mapLoaded}
        getNeighborhoodsSamples={getNeighborhoodsSamples}
        active_mode={active_mode}
        borough_filter={borough_filter}
        formatters={formatters}
        active_probability={active_probability}
        active_neighborhood={active_neighborhood}
        setActiveNeighborhood={setActiveNeighborhood}
        getNeighborhoodHexes={getNeighborhoodHexes}
        setActiveHex={setActiveHex}
        interpolators={interpolators}
        hexes={hexes}
        active_hex={active_hex}
        show_roads={show_roads}
        browser_width={browser_width}
      />
      <Sidebar2
        active_year={active_year}
        active_price={active_price}
        changeActiveYear={changeActiveYear}
        changeActivePrice={changeActivePrice}
        changeActiveMode={changeActiveMode}
        changeActiveProbability={changeActiveProbability}
        changePriceFocus={changePriceFocus}
        neighborhoods={filtered_neighborhoods}
        neighborhoods_samples={neighborhoods_samples}
        formatters={formatters}
        active_mode={active_mode}
        active_probability={active_probability}
        price_focus={price_focus}
        active_neighborhood={active_neighborhood_with_samples}
        probability_focus={probability_focus}
        borough_filter={borough_filter}
        changeProbabilityFocus={changeProbabilityFocus}
        setActiveNeighborhood={setActiveNeighborhood}
        getNeighborhoodHexes={getNeighborhoodHexes}
        closeNeighborhoodFocus={closeNeighborhoodFocus}
        closeHexFocus={closeHexFocus}
        setBoroughFilter={setBoroughFilter}
        interpolators={interpolators}
        active_hex={active_hex_with_samples}
        show_roads={show_roads}
        setShowRoads={setShowRoads}
        setExplainer={setExplainer}
        browser_width={browser_width}
        mobile_toggle={mobile_toggle}
        toggleMobile={toggleMobile}
        mobile_show={mobile_show}
        changeMobileShow={changeMobileShow}
      />
      <YearChanger
        active_year={active_year}
        changeActiveYear={changeActiveYear}
        browser_width={browser_width}
      />
      <Loader
        neighborhoods_samples={neighborhoods_samples}
      />
      {explainer ? (
        <Explainer
          setExplainer={setExplainer}
          browser_width={browser_width}
          changeActiveYear={changeActiveYear}
          changeActiveMode={changeActiveMode}
          changeActivePrice={changeActivePrice}
          changeActiveProbability={changeActiveProbability}
          setActiveNeighborhood={setActiveNeighborhood}
          setExplainer={setExplainer}
          setBoroughFilter={setBoroughFilter}
          setActiveHex={setActiveHex}
          neighborhoods_samples={neighborhoods_samples}
        />
      ) : null}
    </div>
  )
}

export default Apper;



/** WEBPACK FOOTER **
 ** ./src/components/Apper.js
 **/